module.exports = __webpack_public_path__ + "static/media/WCCD_Vertical_White.a9d1d94b.png";